var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterfaceGpsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1,.cls-3,.cls-5{fill:none;}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_101);}.cls-3,.cls-5{stroke:#c7ced3;stroke-miterlimit:10;}.cls-3{stroke-width:2px;}.cls-4{fill:#c7ced3;}.cls-5{stroke-width:6px;}.cls-6{fill:#ff4040;}\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_101",
    x1: 1633,
    y1: 1412.5,
    x2: 1754,
    y2: 1412.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d3236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#31363b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#40444b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#494c55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4c4f58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a5e69"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "interface \xE9cran") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_10",
    "data-name": "Calque 10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 3000,
    height: 3000
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "interface"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1633,
    y: 1301,
    width: 121,
    height: 223
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1632,
    y1: 1413,
    x2: 1754,
    y2: 1413
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1719.88,1339c-2-14.92-14.37-20.94-21.88-21h-.12c-7.51.06-19.89,6.08-21.88,21-1.92,14.42,20.16,42.67,21.88,44.85v.15l.06-.07.06.07v-.15C1699.73,1381.67,1721.8,1353.42,1719.88,1339Zm-21.88,7a6,6,0,1,1,6-6A6,6,0,0,1,1698,1346Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1644,
    y: 1347,
    width: 108,
    height: 8,
    transform: "translate(-457.97 1596.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1663,
    y1: 1456,
    x2: 1730,
    y2: 1425
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1661,1453v47h74v-47Zm28.5,40h-22a3.5,3.5,0,0,1,0-7h22a3.5,3.5,0,0,1,0,7Zm0-10h-22a3.5,3.5,0,0,1,0-7h22a3.5,3.5,0,0,1,0,7Zm0-10h-22a3.5,3.5,0,0,1,0-7h22a3.5,3.5,0,0,1,0,7Zm25.75,21a14.75,14.75,0,1,1,14.75-14.75A14.75,14.75,0,0,1,1715.25,1494Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterfaceGpsInactive);
export default __webpack_public_path__ + "static/media/interface_gps_inactive.4544ec8540a6b0a8fc66709def9996ab.svg";
export { ForwardRef as ReactComponent };